<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-10-13 10:10:26
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\CustomForm\CustomForm\CustomForm.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-07-05 14:28:21
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_customForm_lsit_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-custom-form-type')"
    @new="toNew"
    filterable
    :exportBtn="hasBtn('export-admin-custom-form-type')"
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    @export="exportOut"
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>

    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :filter-page-data="filterPageData"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="table-title text--primary"
            :title="$getCommonLangValue(item.application_type_name)"
          >
            {{ $getCommonLangValue(item.application_type_name) }}
          </div>
        </template>
        <template v-slot:item.code="{ item }">{{
          $getCommonLangValue(item.type_code)
        }}</template>
        <template v-slot:item.approval_flow="{ item }">{{
          $getCommonLangValue(
            item.flow_template_name
              ? item.flow_template_name
              : item.flow_template_uuid
          )
        }}</template>
        <template v-slot:item.status="{ item }">
          <StatusChip
            icon
            :show-icon="false"
            text-color="white--text"
            :bgColor="Number(item.status) === 1 ? 'green' : 'grey'"
          >
            <template v-slot:status>
              {{
                Number(item.status) === 1
                  ? $t("label_essweb_system_status_onLabel")
                  : $t("label_essweb_system_status_offLabel")
              }}
            </template>
          </StatusChip>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-custom-form-type')"
            :editBtn="hasBtn('edit-admin-custom-form-type')"
            :viewBtn="hasBtn('view-admin-custom-form-type')"
            otherText="label_essweb_customForm_lsit_previewBtnLabel"
            :title="$t('label_essweb_customForm_lsit_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
          <!--    :delBtn="!Number(item.is_referenced)"
            :editBtn="!Number(item.is_referenced)" -->
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "CustomForm",
  computed: {},
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  data() {
    return {
      showSelect: false,
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_customForm_list_customFormNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_list_customFormCodeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_list_customFormApprovalFlowLabel",
          value: "approval_flow",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_customForm_list_customFormStatusLabel",
          value: "status",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          sortable: false,
          align: "end",
        },
      ],
      desserts: [],
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_customForm_list_customFormNameLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 1,
          name: "code",
          position: "right",
          label: "label_essweb_customForm_list_customFormCodeLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
      filterPageData: null,
    };
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["application_type_name"] = item.value;
        }
        if (item["name"] == "code") {
          data["type_code"] = item.value;
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    exportOut() {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["application_type_name"] = item.value;
        }
        if (item["name"] == "code") {
          data["type_code"] = item.value;
        }
      });
      this.$Request({
        method: "POST",
        table: "ess_common_application_type",
        url: "/application/export-application/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_customForm_lsit_title"),
      });
    },
    toNew: function () {
      this.$toPage("/admin/custom-form-type/add", {});
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_common_application_type",
        url: "/common-application-type/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      })
        .then((res) => {
          that.desserts = res.data;
          that.totalCount = res.totalcount;
          callback ? callback(page, perpage, data) : null;
        })
        .catch((err) => {
          callback ? callback(page, perpage, data) : null;
        });
    },
    toEdit: function (id, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/custom-form-type/edit/"
          : "/admin/custom-form-type/detail/") + id
      );
    },
    toPreview: function (id) {
      this.$toPage("/admin/custom-form-type/preview/" + id);
    },
    toDelete: function (id) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type",
        url: "/common-application-type/delete/",
        data: { uuids: id.toString() },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_customForm_list_deleteCustomFormSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== id);
      });
    },
  },
};
</script>